import React, { useState } from 'react'
import {
  TableRow,
  TableCell,
  TableBody,
  Table,
  TableHead,
  TableContainer,
} from '@material-ui/core'
import Pagination from '../../Pagination/Pagination'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import ActionsMenu from '../../ActionsMenu/ActionsMenu'
import { MoreVert } from '@material-ui/icons'

const PartTable = ({
  parts,
  setPartToEdit,
  setShowAddEditPart,
  setPartToDelete,
  setShowDeleteModal,
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  const Row = ({ part }) => {
    const handleEditPart = () => {
      setPartToEdit(part)
      setShowAddEditPart(true)
    }

    const handleDeletePart = () => {
      setShowDeleteModal(true)
      setPartToDelete(part)
    }

    return (
      <TableRow>
        <TableCell>{part.name}</TableCell>
        <TableCell>
          {part.size.x && (
            <>
              {part.size.x}/{part.size.y}/{part.size.z}
            </>
          )}
        </TableCell>
        <TableCell>{part.size.units}</TableCell>
        <TableCell>{part.tolerance}</TableCell>
        <TableCell>{useDateFormatter(part.createdAt, 'MM-DD-YYYY')}</TableCell>
        <TableCell>{useDateFormatter(part.updatedAt, 'MM-DD-YYYY')}</TableCell>
        <TableCell>
          <ActionsMenu
            icon={<MoreVert />}
            options={[
              { onClick: handleEditPart, label: 'Edit' },
              { onClick: handleDeletePart, label: 'Delete' },
            ]}
          />
        </TableCell>
      </TableRow>
    )
  }

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Dimensions</TableCell>
              <TableCell>Units</TableCell>
              <TableCell>Tolerance</TableCell>
              <TableCell>Date added</TableCell>
              <TableCell>Last updated</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? parts.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : parts
            ).map((part, index) => (
              <Row key={index} part={part} />
            ))}
          </TableBody>
        </Table>
        <Pagination
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          rows={parts}
        />
      </TableContainer>
    </>
  )
}

export default PartTable
